import React from 'react';

interface IProps {
  children: React.ReactNode;
}

const ZeroState = ({children}: IProps) => {
  return (
    <tr data-testid="beers-manager-zero-state">
      <td colSpan={10}>{children}</td>
    </tr>
  );
};

export default ZeroState;
